import PropTypes from "prop-types";
import React from "react";
import { Paper, withStyles } from "@material-ui/core";

const styles = () => ({
  paper: {
    padding: 30,
    background: "transparent",
    borderRadius: 0,
    boxShadow: "none"
  }
});

const SideBarRight = ({ classes, infoSide }) => {
  return (
    <Paper className={classes.paper}>
      <div className="wrap-icon-info">
        <span className="icon-info">i</span>
      </div>
      <div dangerouslySetInnerHTML={{ __html: infoSide }} />
    </Paper>
  );
};

SideBarRight.propTypes = {
  classes: PropTypes.shape({
    paper: PropTypes.any
  }),
  infoSide: PropTypes.string
};

export default withStyles(styles)(SideBarRight);
